import { SelectionType } from '@philips-internal/oswald-ui-constants';
class BaseCardListContext {
    /**
     * Returns whether it is allowed to select cards.
     *
     * @param selectable - Deck property that dictates whether it is selectable.
     * @param selectionType - Deck property that dictates the type of selection.
     */
    allowCardSelection(selectable, selectionType) {
        return selectable && [SelectionType.MULTIPLE, SelectionType.SINGLE].includes(selectionType);
    }
    /**
     * Returns a new set of selected cards, based on the type of selection or whether to remove an card from the selection.
     *
     * @param args - Arguments to build new selection.
     */
    modifyCardSelection(args) {
        const { item, remove, selection, type } = args;
        if (remove) {
            return selection.filter(oldItem => oldItem !== item);
        }
        return type === SelectionType.MULTIPLE ? [...selection, item] : [item];
    }
    /**
     * Returns if the card is selected.
     *
     * @param key - Card identifier.
     * @param selectionType - Deck property that dictates the type of selection.
     */
    isCardSelected(key, selectedCards) {
        return selectedCards.includes(key);
    }
}
export { BaseCardListContext, };
//# sourceMappingURL=base-card-list-context.js.map